import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCurrentDrawer } from "client/common/hooks/stackables";
import Markdown from "client/common/components/content/Markdown";

// Single newlines within a paragraph render as spaces, so the copy is hard-wrapped for line length
const PROMOTION_DETAILS = `
While supplies last, get a free KONG toy with qualifying NexGard, Heartgard PLUS, and OraVet
purchases.

**Qualifying purchases:**

- First-time Autoship orders of 1, 3, 6 and 12 dose packs of NexGard, NexGard PLUS,
  NexGard COMBO, and Heartgard PLUS, and 30-count bags of OraVet Chews.
- One-time orders of 3, 6 and 12 dose packs of NexGard, NexGard PLUS, NexGard COMBO, and
  Heartgard PLUS, and 30-count bags of OraVet Chews.

**How it works**

1. Place a qualifying order
2. After your purchase, we'll email you a short form so you can choose your KONG toy and size
3. Supplies are limited. We recommend submitting the form as soon as possible. Your KONG will
   ship after your qualifying order ships. Expect it 2-3 weeks after your qualifying order.

**Terms & Conditions**

Limit one KONG toy per customer. Qualifying orders only. Recurring Autoship shipments do not
qualify. To claim your free KONG, you must submit the form sent after your qualifying purchase.
The form will close once supplies run out, and a qualifying purchase does not guarantee a toy if
supplies have run out. KONG toys ship separately from your order and should arrive 2-3 weeks
after your qualifying order. Toy styles and sizes depend on availability. All promotion elements
will end by November 1, 2026, or while supplies last. Vetcove may change, suspend, or end this
promotion at any time without notice. This offer cannot be exchanged for cash or credit. Kong
Company is not affiliated with, nor a sponsor of, this promotion. All third-party trademarks,
logos, and product names are the property of their respective owners.
`;

const BiFreeToyDrawer = () => {
  const { close } = useCurrentDrawer();

  return (
    <DrawerLayout>
      <DrawerLayout.Header title="Free KONG with purchase" onClose={close} />
      <DrawerLayout.Content>
        <Markdown markdown={PROMOTION_DETAILS} />
      </DrawerLayout.Content>
    </DrawerLayout>
  );
};

export default BiFreeToyDrawer;
